export default {
  path: 'plan',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'index',
      name: 'jxxfWbPlanIndex',
      component: () => import('@/features/jxxf/wb/plan/index.vue'),
      meta: {
        navtabTitle: '维保计划管理',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'create',
      name: 'jxxfWbPlanCreate',
      component: () => import('@/features/jxxf/wb/plan/planDialog.vue'),
      meta: {
        navtabTitle: '新建维保计划',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'project/:xmId',
      name: 'jxxfWbPlanProjectList',
      component: () => import('@/features/jxxf/wb/plan/projectPlanList.vue'),
      meta: {
        navtabTitle: '项目维保计划',
        isCache: false,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'detail/:id',
      name: 'jxxfWbPlanDetail',
      component: () => import('@/features/jxxf/wb/plan/planDetail.vue'),
      meta: {
        navtabTitle: '查看维保计划',
        isCache: false,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};
